// resources/js/components/StartpageContent.js

import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import '/css/app.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import p_Lukas from '/images/Lukas_Will_4.webp';
import p_Jacqueline from '/images/Bigwood_Jacqueline_02.webp';

/* import p_Lukas from '../../img/about/Lukas_Will_4.webp';
import p_Jacqueline from '../../img/about/Bigwood_Jacqueline_02.webp'; */

export default function ContactContent() {
    return (
        <div className="row d-flex justify-content-center">
            <div className="col-md-9">
                <div>
                    <h1 className="text-center mt-3">Contact</h1>
                </div>


                <div className="fs-7 mb-2 row justify-content-center">
                    <div className="col-sm-6 px-sm-2 my-2 px-0 lukas-card">
                        <div className="card">
                            <div className="row w-100">
                                <div className="col-xxl-4">
                                    <img src={p_Lukas} alt="Contact Lukas Will" className="my-2 mx-2 align-self-start aboutus_contactPicture img-fluid w-100"/>
                                </div>
                                <div className="col-xxl-8">
                                    <div className="card-body text-nowrap">
                                        <div className="card-title mx-2 schum-color fw-bold">
                                            Mr. Lukas Will
                                        </div>
                                        <div className="card-subtitle mx-2 schum-color">
                                            Operations Manager
                                        </div>
                                        <div className="card-subtitle mx-2">
                                            Mail: <a href="mailto:l.will@schum.de" className="text-decoration-none">l.will@schum.de</a>
                                        </div>
                                        <div className="card-subtitle mx-2">
                                            Phone: <a href="phone:+4993120012858" className="text-decoration-none">+49 (931) 20012-858</a>
                                        </div>
                                        <div className="card-subtitle mx-2 mb-1">
                                            Mobile: <a href="phone:+4915255247613" className="text-decoration-none">+49 (0) 1525 5247613</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <br className="d-sm-none"/> */}

                    <div className="col-sm-6 px-sm-2 my-2 px-0">
                        <div className="card">
                            <div className="row w-100">
                                <div className="col-xxl-4">
                                    <img src={p_Jacqueline} alt="Contact Jacqueline Bigwood" className="my-2 mx-2 align-self-start aboutus_contactPicture img-fluid w-100"/>
                                </div>
                                <div className="col-xxl-8">
                                    <div className="card-body text-nowrap">
                                        <div className="card-title mx-2 schum-color fw-bold">
                                            Ms. Jacqueline Bigwood
                                        </div>
                                        <div className="card-subtitle mx-2 schum-color">
                                            Sales Development Manager
                                        </div>
                                        <div className="card-subtitle mx-2">
                                            Mail: <a href="mailto:j.bigwood@schum.de" className="text-decoration-none">j.bigwood@schum.de</a>
                                        </div>
                                        <div className="card-subtitle mx-2">
                                            Phone: <a href="phone:+4993120012847" className="text-decoration-none">+49 (931) 20012-847</a>
                                        </div>
                                        <div className="card-subtitle mx-2 mb-1">
                                            Mobile: <a href="phone:+491726724596" className="text-decoration-none">+49 (0) 172 6724596</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div>
                    <h6 className="text-center mt-3 mb-3">J. E. Schum (Asia) Limited, Unit 1113, 11F, Winful Industrial Building, 15 Tai Yip Street, Kwun Tong, HONG KONG</h6>
                </div>
            </div>
        </div>
    );
}

if (document.getElementById('contact-content')) {
    const container = document.getElementById('contact-content');
    const root = createRoot(container); // createRoot(container!) if you use TypeScript
    root.render(<ContactContent />);
}